import { API_URL } from './constantes';

export const armarUrl = (uri: string) => {
  if (/https?:\/\//.test(uri)) {
    return uri;
  }
  return uri.startsWith('/') ? `${API_URL}/fotos${uri}` : `${API_URL}/fotos/${uri}`;
};
